<template>
  <div class="error-modal">
    <div class="error-modal-content" v-html="text"></div>
  </div>
</template>

<script>
export default {
  name: 'ErrorModal',
  props: {
    text: {
      type: String,
      default: 'Something went wrong.<br>Please try again.',
    },
  },
};
</script>

<style lang="scss" scoped>
.error-modal {
  transition: box-shadow 1s;
}
.error-modal-content {
  @apply p-5 m-5 text-center;
}
</style>
